<div class="min-h-screen bg-gradient-to-t from-primary/20 to-primary/5 flex flex-col">
  <header class="bg-white shadow-sm py-3 px-6 flex items-center gap-4">
    <img [src]="logo" alt="Logo" class="h-10 object-contain" />
    <span class="text-primary font-semibold text-lg tracking-wide">Accommodation Booking</span>
  </header>

  <app-loading-indicator *ngIf="loading" position="relative -mb-2"></app-loading-indicator>

  <main class="flex-1 p-4 md:p-8 max-w-screen-md mx-auto w-full">
    <ng-content></ng-content>
  </main>
</div>
